import * as React from 'react';
import { IEpiProps } from '../../state-helpers/epi-props';
import { ISearchContext, ContextIds } from '../../../global/models/search-context';

export interface INoAutocompleteResultsProps {
    epiProps: IEpiProps;
    selectedContext: ISearchContext;
}

export class NoAutocompleteResults extends React.Component<INoAutocompleteResultsProps, any> {
    render() {

        const contextString = this.props.selectedContext.display;

        const urlRegex = /context=.+?(&|$)/;
        const javascriptLink = window.location.href.replace(urlRegex, `context=${ContextIds.all}&`)

        const htmlString = this.props.epiProps.noAutocompleteResultsErrorText
            .replace('{{context}}', contextString)
            .replace('http://{{allAAP}}', javascriptLink);

        return (
            <div className="no-results" dangerouslySetInnerHTML={{ __html: htmlString }} />
        );
    }
}